import { createSlice } from '@reduxjs/toolkit';

const initialState = { prompt: null, error: null };

const promptSlice = createSlice({
  name: 'prompt',
  initialState,
  reducers: {
    promptHandler(state, action) {
      state.prompt = action.payload.promptData || null;
      state.error = action.payload.error || null;
    },
    clearPrompt(state) {
      state.prompt = null;
      state.error = null;
    },
  },
});
export const promptAction = promptSlice.actions;
export default promptSlice;